import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum ModifyIconVariant {
  MODIFY1 = '1',
  MODIFY2 = '2',
  MODIFY3 = '3',
}

export interface IModifyIconProps extends IConDefaultType {
  variant?: ModifyIconVariant;
}

function ModifyIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = ModifyIconVariant.MODIFY1,
}: IModifyIconProps) {
  return (
    <i
      className={cn(`dds-icon`, className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === ModifyIconVariant.MODIFY1 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" fill="#CCCCCC" />
          <path
            d="M17.9998 8.98458C18.0015 9.25303 17.9493 9.51908 17.8462 9.76689C17.7431 10.0147 17.5913 10.2392 17.3998 10.427L17.0638 10.7636C17.0095 10.8234 16.9437 10.8715 16.8703 10.9052C16.797 10.9389 16.7176 10.9574 16.637 10.9597C16.5563 10.9619 16.476 10.9478 16.4009 10.9183C16.3258 10.8887 16.2574 10.8443 16.1999 10.7876L13.1999 7.78253C13.0881 7.66992 13.0254 7.51759 13.0254 7.35881C13.0254 7.20002 13.0881 7.04769 13.1999 6.93508L13.5359 6.59851C13.7248 6.40879 13.9492 6.25827 14.1963 6.15557C14.4434 6.05286 14.7083 6 14.9759 6C15.2434 6 15.5083 6.05286 15.7554 6.15557C16.0025 6.25827 16.2269 6.40879 16.4159 6.59851L17.3998 7.54813C17.5906 7.73526 17.742 7.95879 17.845 8.20551C17.9481 8.45223 18.0007 8.71713 17.9998 8.98458Z"
            fill="white"
          />
          <path
            d="M15.558 11.3887C15.6697 11.5013 15.7324 11.6536 15.7324 11.8124C15.7324 11.9712 15.6697 12.1235 15.558 12.2361L10.704 17.0984C10.4288 17.3825 10.0996 17.6087 9.73591 17.7635C9.37218 17.9183 8.98121 17.9987 8.586 18H7.20001C6.88175 18 6.57652 17.8733 6.35148 17.6479C6.12644 17.4225 6.00001 17.1167 6.00001 16.7979V15.3915C5.9989 14.9969 6.07633 14.606 6.22777 14.2418C6.37921 13.8775 6.60162 13.5471 6.88201 13.2699L11.712 8.38357C11.8244 8.27163 11.9765 8.2088 12.135 8.2088C12.2935 8.2088 12.4456 8.27163 12.558 8.38357L15.558 11.3887Z"
            fill="white"
          />
        </svg>
      )}
      {variant === ModifyIconVariant.MODIFY2 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle opacity="0.3" cx="12" cy="12" r="10" fill="black" />
          <path
            d="M17.3999 7.56346L16.4159 6.59748C16.227 6.40808 16.0026 6.25782 15.7555 6.1553C15.5084 6.05277 15.2435 6 14.976 6C14.7085 6 14.4436 6.05277 14.1965 6.1553C13.9494 6.25782 13.7249 6.40808 13.536 6.59748L6.85816 13.2753C6.58211 13.554 6.36413 13.8847 6.21685 14.2483C6.06957 14.6119 5.99592 15.001 6.00017 15.3933V16.7973C6.00017 17.1155 6.1266 17.4207 6.35164 17.6458C6.57668 17.8708 6.8819 17.9972 7.20015 17.9972H8.61012C9.00404 17.9983 9.39424 17.9209 9.75789 17.7695C10.1215 17.618 10.4514 17.3956 10.7281 17.1152L17.3999 10.4434C17.5921 10.2552 17.7443 10.0301 17.8474 9.78162C17.9505 9.53315 18.0024 9.26642 17.9999 8.99743C18.0008 8.73044 17.9481 8.46599 17.8451 8.2197C17.742 7.97341 17.5907 7.75026 17.3999 7.56346ZM9.85809 16.2753C9.51988 16.6107 9.06248 16.7984 8.58612 16.7973H7.20015V15.3933C7.20057 14.9161 7.39048 14.4585 7.72814 14.1213L12.9 8.94943L15.054 11.1034L9.85809 16.2753ZM16.5359 9.59741L15.882 10.2574L13.728 8.10345L14.4 7.44346C14.5597 7.28558 14.7754 7.19717 15 7.19747C15.1113 7.19667 15.2217 7.218 15.3247 7.26023C15.4277 7.30246 15.5212 7.36474 15.6 7.44346L16.5359 8.39744C16.6177 8.47486 16.6831 8.5678 16.7284 8.67082C16.7737 8.77385 16.7981 8.88489 16.7999 8.99743C16.7948 9.22448 16.6999 9.44024 16.5359 9.59741Z"
            fill="white"
          />
        </svg>
      )}
      {variant === ModifyIconVariant.MODIFY3 && (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M17.9999 5.97943C18.0022 6.33737 17.9325 6.6921 17.795 7.02252C17.6576 7.35293 17.4552 7.65226 17.1999 7.90271L16.7519 8.35148C16.6795 8.43115 16.5917 8.49536 16.4939 8.54028C16.3961 8.58519 16.2903 8.60989 16.1827 8.61288C16.0752 8.61587 15.9681 8.5971 15.868 8.55769C15.7679 8.51829 15.6767 8.45905 15.5999 8.38353L11.5999 4.3767C11.4509 4.22656 11.3673 4.02345 11.3673 3.81174C11.3673 3.60003 11.4509 3.39693 11.5999 3.24678L12.0479 2.79801C12.2999 2.54505 12.5991 2.34436 12.9286 2.20742C13.258 2.07049 13.6112 2 13.9679 2C14.3246 2 14.6778 2.07049 15.0073 2.20742C15.3367 2.34436 15.636 2.54505 15.8879 2.79801L17.1999 4.06417C17.4542 4.31368 17.6561 4.61172 17.7935 4.94067C17.9309 5.26963 18.0011 5.62284 17.9999 5.97943Z"
            fill={color || '#ADB0B8'}
          />
          <path
            d="M14.744 9.18493C14.893 9.33507 14.9766 9.53818 14.9766 9.74989C14.9766 9.9616 14.893 10.1647 14.744 10.3149L8.27199 16.7979C7.90505 17.1767 7.46619 17.4782 6.98121 17.6847C6.49623 17.8911 5.97494 17.9983 5.448 17.9999H3.60001C3.17566 17.9999 2.7687 17.8311 2.46864 17.5305C2.16858 17.2299 2.00002 16.8223 2.00002 16.3972V14.522C1.99854 13.9959 2.10178 13.4747 2.30369 12.989C2.50561 12.5033 2.80216 12.0628 3.17601 11.6932L9.61598 5.1781C9.76587 5.02884 9.96863 4.94507 10.18 4.94507C10.3913 4.94507 10.5941 5.02884 10.744 5.1781L14.744 9.18493Z"
            fill={color || '#ADB0B8'}
          />
        </svg>
      )}
    </i>
  );
}

export default ModifyIcon;
